import { render, staticRenderFns } from "./category-menu-add.vue?vue&type=template&id=17a2f290&scoped=true"
import script from "./category-menu-add.vue?vue&type=script&lang=js"
export * from "./category-menu-add.vue?vue&type=script&lang=js"
import style0 from "./category-menu-add.vue?vue&type=style&index=0&id=17a2f290&prod&scoped=true&lang=css"
import style1 from "./category-menu-add.vue?vue&type=style&index=1&id=17a2f290&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17a2f290",
  null
  
)

export default component.exports